import React from "react";
import "./SearchResult.css";
import { Link } from "react-router-dom";

interface SearchResultProps {
  searchResults: any[];
  isOpen: boolean;
  onResultClick: () => void; // Add this prop to handle result clicks
}

const SearchResult: React.FC<SearchResultProps> = ({
  searchResults,
  isOpen,
  onResultClick,
}) => {
  return (
    <>
      {searchResults.length > 0 && isOpen && (
        <div className="col-lg-12">
          <div className="header-box-custom my-2">
            {searchResults.map((result) => (
              <Link
                to={{
                  pathname: `/${result.public_id}`,
                }}
                state={{ id: result.id }}
                className="text-decoration-none search-result-title"
                onClick={onResultClick}
                key={result.id}
              >
                <div className="d-flex align-items-start mb-2 search-result-items">
                  <figure className="mb-0 ">
                    {result.image_url ? (
                      <img
                        src={result.image_url}
                        alt={result.name}
                        className="search-image"
                      />
                    ) : (
                      <div
                        style={{ borderRadius: "4px 4px 0px 0px" }}
                        className={`user-img text-dark-purple bg-extra-light-purple d-flex justify-content-center align-items-center chat-image`}
                      >
                        <i
                          className="fa-solid fa-user"
                          style={{ fontSize: 20 }}
                        ></i>
                      </div>
                    )}
                  </figure>
                  <div className="ms-2 p-1">
                    {result.name}
                    <p className="mb-0 search-result-desc search-bio">
                      {result.bio}
                    </p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default SearchResult;
